import { useDrag } from "react-dnd";

const User_SetRoleStat_RoleCard_Big = (props) => {
    const [{ opacity }, drag] = useDrag(
        () => ({
            item: {
                name: props.index + 1,
                type: "role" },
            collect: (monitor) => ({
                opacity: monitor.isDragging() ? 0 : 1
            })
        }),
        [props.index + 1, "role" ]
    );
    let card = null;
    if(!props.isAvaliable){
        card = <div ref={drag} className='user-set-role-state-role-card-content-container' style={{ opacity: opacity }}>
            <img alt={"icon"} src={props.roleBG} className='user-set-role-state-role-image'/>
            <div className='user-set-role-state-role-text'>{props.roleName}</div>
        </div>
    }
    return <div className='user-set-role-state-role-card' >
        {card}
    </div>
}
export default User_SetRoleStat_RoleCard_Big;
